import './PortMenu.css'
import 'antd/dist/reset.css'
import React from 'react'
import { ConfigProvider, Drawer, Tabs, Collapse, Menu, Button } from 'antd'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import { industries } from '../../products/ProductProvider'
import PortProductPanel from './PortProductPanel'

export const menuHeight = '100%'

export default class PortMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <Drawer
        height={menuHeight}
        title={null}
        placement="top"
        closeIcon={null}
        open={this.props.menuExpanded}
        mask={false}
        rootStyle={{
          position: 'fixed',
          top: '7vh',
          zIndex: 100,
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Collapse: {
                headerPadding: 0,
                contentPadding: 0,
                contentBg: '#000000',
              },
            },
          }}
        >
          <Collapse
            expandIcon={({ isActive }) => (
              <DownOutlined rotate={isActive ? -180 : 0} />
            )}
            expandIconPosition="end"
            items={this.getMenuItems()}
            accordion
            ghost
            onChange={(key) => {
              this.setState({ activeKey: key })
              setTimeout(() => {
                console.log('activeKey: ' + this.state.activeKey)
              }, 2000)
            }}
          />
        </ConfigProvider>
      </Drawer>
    )
  }

  getMenuItems = () => {
    const items = []
    items.push(this.getProductItems())
    items.push(this.getIndustryItems())
    items.push(this.getCompanyItems())
    items.push(this.getInnovationItems())
    return items
  }

  getProductItems = () => {
    const item = {
      key: 'product',
      label: <div className="PortMenuTitle">产品</div>,
      children: (
        <div
          style={{
            background: '#F6F6F6',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          <Tabs
            items={[
              {
                key: 'customer',
                label: '按行业公司',
                children: <PortProductPanel entry="customer" {...this.props} />,
              },
              {
                key: 'variety',
                label: '按品种',
                children: <PortProductPanel entry="variety" {...this.props} />,
              },
            ]}
            style={{ fontFamily: 'MyCustomizedFont' }}
          />

          <Button
            color="green"
            variant="text"
            style={{
              fontSize: 13,
              fontWeight: 'bold',
              marginBottom: 10,
              fontFamily: 'MyCustomizedFont',
            }}
            icon={<RightOutlined style={{ fontSize: 13 }} />}
            iconPosition="end"
            onClick={() => {
              this.props.handleCollapse()
              this.viewProductList()
            }}
          >
            查看所有产品
          </Button>
        </div>
      ),
      style: { marginBottom: 30 },
    }
    return item
  }

  getIndustryItems = () => {
    const item = {
      key: 'industry',
      label: <div className="PortMenuTitle">行业</div>,
      children: (
        <Menu
          items={industries.map((industry) => {
            return {
              key: industry.iid,
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewIndustryInfo(industry.iid)
                  }}
                >
                  {industry.name}
                </div>
              ),
            }
          })}
          selectable={false}
        />
      ),
      style: { marginBottom: 30 },
    }
    return item
  }

  getCompanyItems = () => {
    const item = {
      key: 'company',
      label: <div className="PortMenuTitle">公司</div>,
      children: (
        <Menu
          items={[
            {
              key: 'about us',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewCompanyInfo()
                  }}
                >
                  公司介绍
                </div>
              ),
            },
            {
              key: 'certificates',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewCertificates()
                  }}
                >
                  资质证书
                </div>
              ),
            },
            {
              key: 'document',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.downloadFile(
                      'https://www.keystridevalve.com/files/%E7%AE%A1%E4%BB%B6%E4%B8%8E%E9%98%80%E9%97%A8.pdf'
                    )
                  }}
                >
                  产品文档（管件与阀门）
                </div>
              ),
            },
            {
              key: 'contact',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewContactMethod()
                  }}
                >
                  联系方式
                </div>
              ),
            },
          ]}
          selectable={false}
        />
      ),
      style: { marginBottom: 30 },
    }
    return item
  }

  getInnovationItems = () => {
    const item = {
      key: 'innovation',
      label: <div className="PortMenuTitle">Keystride创新</div>,
      children: (
        <Menu
          items={[
            {
              key: 'product_line',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewProductLine()
                  }}
                >
                  定制化柔性生产线
                </div>
              ),
            },
            {
              key: 'overall_solution',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewOverallSolution()
                  }}
                >
                  整体解决方案
                </div>
              ),
            },
            {
              key: 'onsite_guidance',
              label: (
                <div
                  style={{ fontFamily: 'MyCustomizedFont' }}
                  onClick={() => {
                    this.props.handleCollapse()
                    this.viewOnsiteGuidance()
                  }}
                >
                  现场工程指导
                </div>
              ),
            },
          ]}
          selectable={false}
        />
      ),
    }
    return item
  }

  downloadFile = (fileUrl) => {
    // const a = document.createElement('a')
    // a.style.display = 'none'
    // a.href = fileUrl
    // a.target = '_blank'
    // a.rel = 'noopener noreferrer'
    // a.download = ''
    // document.body.appendChild(a)
    // a.click()
    // document.body.removeChild(a)
    window.open(fileUrl, '_blank')
  }

  viewProductDetail = (pid) => {
    this.props.history.push('/product?pid=' + pid)
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  viewIndustryInfo = (iid) => {
    this.props.history.push('/industry?iid=' + iid)
  }

  viewCompanyInfo = () => {
    this.props.history.push('/company')
  }

  viewCertificates = () => {
    this.props.history.push('/certificates')
  }

  viewContactMethod = () => {
    this.props.history.push('/contact')
  }

  viewProductLine = () => {
    this.props.history.push('/product_line')
  }

  viewOverallSolution = () => {
    this.props.history.push('/overall_solution')
  }

  viewOnsiteGuidance = () => {
    this.props.history.push('/onsite_guidance')
  }
}
